import {Typography, TypographyProps} from '@mui/material';
import {styled} from '@mui/material/styles';

const Gradient = styled(Typography)(({theme}) => ({
  backgroundImage: `linear-gradient(97.99deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 101.11%)`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

export const GradientText = ({
  children,
  sx = {},
  ...other
}: TypographyProps) => (
  <Gradient sx={{...sx}} {...other}>
    {children}
  </Gradient>
);
